// Crew numbers for reports: "on board" is the same rule as the AI's "who is on board?" (crew.onboard = true, not archived).
// Crew records = every crew row that is not archived (on board or not).
export const isOnBoard = c => c && c.onboard === true && c.archived !== true
export function crewCounts(rows) {
  const active = (rows || []).filter(c => c && c.archived !== true)
  return { records: active.length, onBoard: active.filter(isOnBoard).length }
}
// the sentence the report AI is given (authoritative figure)
export const crewFact = n => n.records === n.onBoard
  ? `Crew: ${n.onBoard} on board.`
  : `Crew: ${n.onBoard} on board (${n.records} crew records in total - always say "${n.onBoard} on board", never call ${n.records} the crew or team size).`
